import { E164Number } from 'libphonenumber-js'
import { UserWalletType } from '../Wallet/Wallet'
import { Language } from '../Language'
import { PayoutDistributionTransactionErrorFlags } from '../Payout'
import { Verification } from './UserVerification'

export enum UserAccountType {
  INDIVIDUAL = 0,
  COMPANY = 1,
}

export type CompanyLegalFormTranslationKey =
  | 'sas'
  | 'sasu'
  | 'sarl'
  | 'eurl'
  | 'sa'
  | 'snc'
  | 'sci'
  | 'scop'
  | 'scic'
  | 'ei'
  | 'association1901'
  | 'other'

export type CompanyLegalFormOption = {
  value: string
  translationKey?: CompanyLegalFormTranslationKey
}

export const COMPANY_LEGAL_FORM_OPTIONS: CompanyLegalFormOption[] = [
  { value: 'SAS', translationKey: 'sas' },
  { value: 'SASU', translationKey: 'sasu' },
  { value: 'SARL', translationKey: 'sarl' },
  { value: 'EURL', translationKey: 'eurl' },
  { value: 'SA', translationKey: 'sa' },
  { value: 'SNC', translationKey: 'snc' },
  { value: 'SCI', translationKey: 'sci' },
  { value: 'SCOP', translationKey: 'scop' },
  { value: 'SCIC', translationKey: 'scic' },
  { value: 'EI', translationKey: 'ei' },
  { value: 'Association loi 1901', translationKey: 'association1901' },
  { value: 'AUTRE', translationKey: 'other' },
]

export interface User {
  id: string
  email: string
  firstname?: string
  lastname?: string
  gender?: UserGenders
  job?: UserJobs
  birthday?: string
  addressStreet?: string
  addressCity?: string
  addressZipcode?: string
  addressCountry?: string
  phone?: E164Number
  verificationId?: string
  verification?: Verification
  nationality?: string
  accountType?: UserAccountType
  companyName?: string
  companyRegistrationNumber?: string
  companyVatNumber?: string
  companyLegalForm?: string
}

// todo: merge with with User interface
export interface UserInfo {
  firstname: string | null
  lastname: string | null
  gender: UserGenders | null
  job: UserJobs | null
  birthday: string | null
  addressStreet: string | null
  addressCity: string | null
  addressZipcode: string | null
  addressCountry: string | null
  phone: E164Number | null
  nationality: string | null
  accountType?: UserAccountType | null
  companyName?: string | null
  companyRegistrationNumber?: string | null
  companyVatNumber?: string | null
  companyLegalForm?: string | null
}

export enum UserGenders {
  MALE = 'm',
  FEMALE = 'f',
  OTHER = 'n',
}
export enum UserJobs {
  STUDENT = 'student',
  LIBERAL = 'liberal',
  EMPLOYEE = 'employee',
  EXECUTIVE = 'executive',
}

export interface UserWallet {
  id: string
  name: string
  address: string
  addressIndex: number
  walletType: UserWalletType
  status: UserWalletStatus
  createdAt: string
  updatedAt: string
}

export interface SheltersNft {
  identifier: string
  ticker: string
  nonce: number
  balance: number
}

export interface NextPayout {
  id: string
  nftNonce: number
  nftCollectionId: number
  fractionCurrentPrice: number
  rentalYieldPerYear: number
  total: number
  nextYield: {
    monthlyYields: number
    yearlyYields: number
    yearlyCapitalGain: number
  }
}

export interface SinglePayout {
  totalAmount: number
}

export interface PayoutHistory {
  paidAt: string
  payouts: Record<string, SinglePayout>
  errorPayouts: {
    grossEurTotal: number
    errorFlags: PayoutDistributionTransactionErrorFlags[]
  }
}

export enum UserWalletStatus {
  DISABLED = 'disabled',
  ACTIVE = 'active',
}

export interface getBillingAddressesResponse {
  billingAddresses: BillingAddress[]
  pagination: any
}

export interface BillingAddress {
  id: string
  userId: string
  firstname: string
  lastname: string
  addressStreet: string
  addressCity: string
  addressZipcode: string
  addressCountry: string
}

export interface UserPreferences {
  id: string
  userPayoutMethodId?: string
  nextUserPayoutMethodId?: string
  updatedAt: Date
  lang: Language
}
